/* Volti Games — base: utilidades, desplegables, filas, acordeón, buscador y header. Los datos los entrega Shopify. */
(() => {
  const d = document, C = window.VG_CFG || { routes: {} }, R = C.routes;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = d) => r.querySelector(s);
  const $$ = (s, r = d) => [...r.querySelectorAll(s)];
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  const plural = (n, a, b) => n === 1 ? a : b;
  const tierMsg = n => n <= 0 ? 'Lleva 2 juegos y obtén −5%' : n === 1 ? 'Agrega 1 juego más y obtén −5%' : n === 2 ? '¡Tienes −5%! Agrega 1 más y sube a −10%' : n === 3 ? '¡Tienes −10%! Agrega 1 más y llévate el 4x3' : '¡Desbloqueaste el 4x3!';

  /* Entradas al scrollear */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { threshold: .15, rootMargin: '0px 0px -40px 0px' }) : null;
  const reveal = (root = d) => $$('.rv:not(.in), [data-io]:not(.in)', root).forEach(el => io ? io.observe(el) : el.classList.add('in'));

  /* Aviso */
  const toastEl = $('#toast'); let tt;
  const showToast = html => { if (!toastEl) return; toastEl.innerHTML = html; toastEl.classList.add('show'); clearTimeout(tt); tt = setTimeout(() => toastEl.classList.remove('show'), 3200); };

  /* Desplegables propios (moneda, ordenar, motivo) */
  const dropdown = (box, onPick) => {
    const btn = $('.cur__btn', box), opts = $$('.cur__opt', box);
    if (!btn) return;
    const open = on => {
      box.classList.toggle('is-open', on); btn.setAttribute('aria-expanded', on);
      if (on && opts.length) (opts.find(o => o.getAttribute('aria-selected') === 'true') || opts[0]).focus();
    };
    btn.addEventListener('click', () => open(!box.classList.contains('is-open')));
    opts.forEach((o, i) => {
      o.addEventListener('click', () => { opts.forEach(x => x.setAttribute('aria-selected', x === o)); open(false); btn.focus(); onPick(o.dataset.v, o); });
      o.addEventListener('keydown', e => {
        if (e.key === 'ArrowDown') { e.preventDefault(); opts[Math.min(i + 1, opts.length - 1)].focus(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); opts[Math.max(i - 1, 0)].focus(); }
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); o.click(); }
        if (e.key === 'Escape' || e.key === 'Tab') { open(false); btn.focus(); }
      });
    });
    d.addEventListener('click', e => { if (!box.contains(e.target)) open(false); });
  };
  /* Moneda: Shopify Markets (formulario de localización). Los precios ya llegan convertidos. */
  $$('[data-cur]').forEach(box => dropdown(box, v => {
    const f = box.closest('form'); if (!f) return;
    const i = $('[name="country_code"]', f); if (!i || i.value === v) return;
    i.value = v; f.submit();
  }));
  $$('[data-sel]').forEach(box => dropdown(box, (v, o) => {
    const t = $('.sel__t', box); if (t) t.textContent = o.textContent.trim();
    const inp = $('input[type="hidden"]', box); if (inp) inp.value = v;
    if (box.dataset.sel === 'nav') {
      const u = new URL(location.href); u.searchParams.set(box.dataset.param || 'sort_by', v); u.searchParams.delete('page'); location.href = u.toString(); return;
    }
    box.dispatchEvent(new CustomEvent('vg:sel', { detail: v, bubbles: true }));
  }));

  /* Filas con flechas (si la fila ya está enlazada, solo refresca el estado de las flechas) */
  const shelves = (root = d) => $$('.shelf', root).forEach(sh => {
    const row = $('.row', sh); if (!row) return;
    if (sh.dataset.bound) { row.dispatchEvent(new Event('scroll')); return; }
    sh.dataset.bound = 1;
    const [prev, next] = $$('[data-scroll]', sh);
    const upd = () => { if (!prev || !next) return; prev.disabled = row.scrollLeft < 8; next.disabled = row.scrollLeft + row.clientWidth > row.scrollWidth - 8; };
    $$('[data-scroll]', sh).forEach(b => b.addEventListener('click', () => row.scrollBy({ left: +b.dataset.scroll * row.clientWidth * .8, behavior: reduce ? 'auto' : 'smooth' })));
    row.addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd, { passive: true }); upd();
  });

  /* Acordeón: al abrir una pregunta se cierran las demás */
  const bindFaq = root => root.addEventListener('click', e => {
    const b = e.target.closest('.q__btn'); if (!b || !root.contains(b)) return;
    const q = b.parentElement, open = !q.classList.contains('is-open');
    $$('.q.is-open', root).forEach(o => { if (o !== q) { o.classList.remove('is-open'); $('.q__btn', o).setAttribute('aria-expanded', false); } });
    q.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open);
  });
  $$('[data-faq]').forEach(bindFaq);

  /* Buscador: Predictive Search API (/search/suggest) */
  const POP = (window.VG_POP || []).map(s => s.trim()).filter(Boolean);
  const popHTML = () => POP.length ? `<span class="sugg__lbl">Populares</span><div class="sugg__tags">${POP.map(t => `<a href="#" data-q="${esc(t)}">${esc(t)}</a>`).join('')}</div>` : '';
  $$('form.search').forEach(f => {
    const i = $('[data-search]', f), box = $('[data-sugg]', f); if (!i || !box) return;
    let t, ctrl;
    const paint = () => {
      const q = i.value.trim(); clearTimeout(t);
      if (!q) { box.innerHTML = popHTML(); return; }
      t = setTimeout(async () => {
        try {
          if (ctrl) ctrl.abort(); ctrl = new AbortController();
          const r = await fetch(`${R.suggest}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5&section_id=vg-predictive-search`, { signal: ctrl.signal });
          const doc = parse(await r.text()), s = $('.shopify-section', doc);
          if (i.value.trim() === q) box.innerHTML = s ? s.innerHTML : '';
        } catch (e) { /* cancelada */ }
      }, 160);
    };
    i.addEventListener('input', paint); i.addEventListener('focus', paint); box.innerHTML = popHTML();
    box.addEventListener('mousedown', e => { if (e.target.closest('[data-q]')) e.preventDefault(); });
    box.addEventListener('click', e => { const a = e.target.closest('[data-q]'); if (!a) return; e.preventDefault(); i.value = a.dataset.q; paint(); i.focus(); });
  });

  /* Header: se despega al scrollear y la búsqueda se pliega en una lupa */
  const hdr = $('#hdr'), lupa = $('#lupa'), hdrPanel = $('#hdrPanel'), q3 = $('#q3');
  if (hdr && lupa && hdrPanel) {
    const setSearch = on => { hdr.classList.toggle('search-open', on); lupa.setAttribute('aria-expanded', on); if (on) setTimeout(() => q3 && q3.focus(), 60); else if (q3) q3.blur(); };
    lupa.addEventListener('click', () => setSearch(!hdr.classList.contains('search-open')));
    d.addEventListener('click', e => { if (hdr.classList.contains('search-open') && !hdrPanel.contains(e.target) && !lupa.contains(e.target)) setSearch(false); });
    d.addEventListener('keydown', e => { if (e.key === 'Escape' && hdr.classList.contains('search-open')) { setSearch(false); lupa.focus(); } });
    let tk = false;
    const onScroll = () => { if (tk) return; tk = true; requestAnimationFrame(() => { const sc = scrollY > 10; hdr.classList.toggle('is-scrolled', sc); if (!sc && hdr.classList.contains('search-open')) setSearch(false); tk = false; }); };
    addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  shelves(); reveal();
  window.VG = { d, C, R, reduce, $, $$, esc, parse, plural, tierMsg, reveal, showToast, shelves, bindFaq, dropdown };
})();